module.exports = __webpack_public_path__ + "img/26_18.3de2fb42.png";